import React from 'react';

/**
 * Premium rank badge — replaces 🥇🥈🥉 emojis with a refined gold/silver/bronze
 * numbered crest. Roman numerals add a luxe, classical feel.
 */
const RANK_STYLES = {
    1: { label: 'I', from: '#FFD700', to: '#B8860B', text: '#1a1208', shadow: 'rgba(255,215,0,0.35)' },
    2: { label: 'II', from: '#E5E4E2', to: '#9FA0A1', text: '#1a1a1a', shadow: 'rgba(229,228,226,0.3)' },
    3: { label: 'III', from: '#D08C5A', to: '#7B4523', text: '#1a0d05', shadow: 'rgba(208,140,90,0.3)' },
};

const FALLBACK = { label: '', from: '#3a3a3a', to: '#1a1a1a', text: '#9aa0a6', shadow: 'rgba(0,0,0,0.3)' };

export function RankBadge({ rank, size = 'md', showNumber = true, className = '' }) {
    const style = RANK_STYLES[rank] || FALLBACK;
    const dim = size === 'sm' ? 24 : size === 'lg' ? 44 : 32;
    const fontSize = size === 'sm' ? 11 : size === 'lg' ? 16 : 13;

    return (
        <div
            className={`inline-flex items-center justify-center font-bold tracking-tight rounded-md ${className}`}
            style={{
                width: dim,
                height: dim,
                background: `linear-gradient(140deg, ${style.from} 0%, ${style.to} 100%)`,
                color: style.text,
                fontSize,
                fontFamily: '"Cormorant Garamond", "Times New Roman", serif',
                fontWeight: 700,
                boxShadow: `0 1px 0 rgba(255,255,255,0.25) inset, 0 4px 14px ${style.shadow}`,
                border: '1px solid rgba(255,255,255,0.1)',
            }}
            data-testid={`rank-badge-${rank}`}
            aria-label={`Rank ${rank}`}
        >
            {showNumber && (style.label || `#${rank}`)}
        </div>
    );
}
